import cmp from '../../lib/cmp';
import { smap } from '../../lib/utils';
import './sm-landing-appstore-app-1-developer-apps.less';
import { isRtl } from '../../lib/document-dir-utils';



const developerAppItem = (length) => ({ icon, name, subheader }, index) => {
  const isVisibleSeparator = length % 2 ? (index > length - 2) : (index >= length - 2);

  return `
    ${icon && icon.url ? `
      <div class="sm-landing-appstore-app-1-developer-apps__item ${isVisibleSeparator ? 'sm-landing-appstore-app-1-developer-apps__item--separate-hide' : ''}">
        <img class="sm-landing-appstore-app-1-developer-apps__item-image${isRtl() ? '-rtl' : ''}" src="${icon.url}">
        <div class="sm-landing-appstore-app-1-developer-apps__item-content">
          <div class="sm-landing-appstore-app-1-developer-apps__item-content-in">
            ${name ? `<div class="sm-landing-appstore-app-1-developer-apps__item-content-title">${name}</div>` : ''}
            ${subheader ? `<div class="sm-landing-appstore-app-1-developer-apps__item-content-text">${subheader}</div>` : ''}
          </div>
          <div class="sm-landing-appstore-app-1-developer-apps__item-button">
            <div class="sm-landing-appstore-app-1-developer-apps__item-button-in${isRtl() ? '-rtl' : ''}">
              ${__('sm@_get')}
            </div>
          </div>
        </div>
      </div>
    ` : ''}
  `;
};

const template = ($cmp, { apps, developer }) => `
  <div class="sm-landing-appstore-app-1-developer-apps">
    <div class="sm-landing-appstore-app-1-developer-apps__h">${__('sm@_more_by')} ${developer}</div>
    <div class="sm-landing-appstore-app-1-developer-apps__list-wr">
      <div class="sm-landing-appstore-app-1-developer-apps__list">
       ${smap(apps, developerAppItem(apps.length))}
      </div>
    </div>
  </div>
`;



export default cmp(null, template);



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1-developer-apps/sm-landing-appstore-app-1-developer-apps.js